const newColor = {
  2: '#ffffff',
  5: '#000000',
  10: '#262626',
  15: '#F7F7F7',
  20: '#BDBDBD',
  30: '#610B0B',
  40: '#8A0808',
  50: '#DBE5ED',
  60: '#129D12',
  65: '#108B10',
  70: '#240B3B',
  80: '#4B088A',
  90: '#6E6E6E',
  100: '#c5d5e2',
  200: '#fff9b3',
  300: '#fff370',
};

export default newColor;
